var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/swap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 307",
    d: "M5.97466 4.04903C5.94372 3.89433 6.06204 3.75 6.2198 3.75H13.7802C13.938 3.75 14.0563 3.89433 14.0253 4.04903L12.8529 9.91117C12.5809 11.2711 11.3869 12.25 10 12.25C8.61314 12.25 7.41907 11.2711 7.14709 9.91117L5.97466 4.04903Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M14 6H17.2054C17.5736 6 17.8152 6.38363 17.6384 6.70661C16.8154 8.2107 15.2263 10.432 12.5 11",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M6 6H2.79462C2.42644 6 2.18482 6.38363 2.36155 6.70661C3.18456 8.2107 4.77369 10.432 7.5 11",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M10 12.5V15.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 308",
    d: "M8 15.75H12V14.25H8V15.75ZM12 15.75C12.6904 15.75 13.25 16.3096 13.25 17H14.75C14.75 15.4812 13.5188 14.25 12 14.25V15.75ZM8 14.25C6.48122 14.25 5.25 15.4812 5.25 17H6.75C6.75 16.3096 7.30964 15.75 8 15.75V14.25Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.5001b1e9dd12074306276179890abe1b.svg";
export { ForwardRef as ReactComponent };